export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      files: [
        {
          fileId: 3,
          fileUuid: "files003",
          fileName: "bg_cafe.jpg",
          fileUri: "/images/img01.png",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services002",
              serviceName: "〇〇地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 2,
          fileUuid: "files002",
          fileName: "sky.jpg",
          fileUri: "/images/img01.png",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services002",
              serviceName: "〇〇地域サポート"
            },
            {
              serviceUuid: "services004",
              serviceName: "△△地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 1,
          fileUuid: "files001",
          fileName: "ocean.jpg",
          fileUri: "/images/img01.png",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services001",
              serviceName: "アイラ地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        }
      ]
    }
  }
}